import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { combineAll, DcBaseComponent } from '@datachain/ui-sdk/common';
import {
	AppModalService,
	ModalData,
} from '@datachain/ui-sdk/components/app-modal';
import { Observable } from 'rxjs';

import { DcIcons } from '../../../ui/app-dc.icons';

export enum ConnectorAction {
	Delete = 'delete',
}

export interface IConnectorActionModalData {
	connectorId: number | Array<number>;
	element: string;
	action: ConnectorAction;
}
@Component({
	selector: 'app-connector-action-popup',
	templateUrl: './connector-action-popup.component.html',
	styleUrls: ['./connector-action-popup.component.scss'],
})
export class ConnectorActionPopupComponent<
	T extends IConnectorActionModalData
> extends DcBaseComponent {
	protected readonly DcIcons = DcIcons;
	protected readonly ConnectorAction = ConnectorAction;
	public readonly Icons = DcIcons;
	public vo$: Observable<{
		element: string;
		connectorId: number | Array<number>;
		isMultipleElement: boolean;
		action: ConnectorAction;
	}>;
	public confirmDeletion = false;

	public constructor(
		private readonly modalService: AppModalService,
		@Inject(MAT_DIALOG_DATA) public readonly modalData: ModalData & T
	) {
		super();
		this.cmpId = 'connector-action';

		this.vo$ = combineAll({
			element: this.modalData.element,
			isMultipleElement:
				Array.isArray(this.modalData.connectorId) &&
				this.modalData.element === '',
			connectorId: this.modalData.connectorId,
			action: this.modalData.action,
		});
	}

	public confirmAction(): void {
		this.modalService.closeActiveModal({
			shouldLaunch: true,
		});
	}
}
